// componente che contiene i metodi di gestione dati dell'utente corrente

import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../../service/api.service';
import { AuthenticationService } from '../../../service/authentication.service';
import { AlertService } from 'src/app/service/alert.service';

// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
  username: string;
  telephone: string;
  email: string;
  firstname: string;
  lastname: string;
  bodyid: string;
  profile: string;
  token: string;
}

@Component({
  selector: 'personaldata',
  templateUrl: './personaldata.html',
  styleUrls: ['./style.scss']
})
export class PersonalDataComponent implements OnInit {
  currentUser: User;
  profs = ["Admin", "User", "SuperAdmin"];
  profile = "";
  constructor(private als: AlertService, public dialog: MatDialog,
    public dataStorageService: ApiService, private authenticationService: AuthenticationService) { }

  // all'inizio viene impostato come utente corrente quello letto dal servizio di autenticazione
  ngOnInit() {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x)
  }

  // metodo che invia al back-end i dati dell'utente modificati
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var user = this.currentUser;

    // se c'è stata una modifica viene inserita nell'apposito campo; altrimenti viene inserito il valore non modificato
    var mess = {
      telephone: value.telephone ? value.telephone : user['telephone'],
      firstname: value.firstname ? value.firstname : user['firstname'],
      lastname: value.lastname ? value.lastname : user['lastname'],
      email: value.email ? value.email : user['email'],
      password: value.password ? value.password : undefined
    }

    // richiamo dell'apposito s ervizio di back-end
    this.dataStorageService.updatePersonal(mess)

    const conf = this.als.confirm("Ripetere login per rendere effettive le modifiche").subscribe(x => {
      if (x === true) {
        setTimeout(function () {
          me.authenticationService.logout()
        }, 500);
      }
      conf.unsubscribe();

    });

  }

  // metodo che imposta il nome del profilo
  addProfile(vs) {
    this.profile = vs
  }

  // metodo di cancellazione dell'utente corrente
  onDelete() {
    var me = this
    var user = this.currentUser;
    var username = user.username

    const conf = this.als.confirm("Sei sicuro di voler eliminare il tuo account?").subscribe(x => {
      if (x === true) {
        me.dataStorageService.deleteUser(username)
        setTimeout(function () {
          me.authenticationService.logout()
        }, 500);
      }
      conf.unsubscribe();

    });

  }

}

